export default __webpack_public_path__ + "static/media/mb.04dfed8f.svg";